import { createContext, useContext, useEffect, useRef, useState } from 'react'

const FooterVisibilityContext = createContext({ isVisible: false })

// eslint-disable-next-line react-refresh/only-export-components
export const useFooterVisibility = () => useContext(FooterVisibilityContext)

export const FooterVisibilityProvider = ({
 children
}: {
 children: React.ReactNode
}) => {
 const [isVisible, setIsVisible] = useState(false)
 const footerRef = useRef<HTMLElement | null>(null)

 useEffect(() => {
  footerRef.current = document.querySelector('footer')

  if (!footerRef.current) return

  const observer = new IntersectionObserver(
   ([entry]) => setIsVisible(entry.isIntersecting),
   { threshold: 0.1 }
  )

  observer.observe(footerRef.current)

  return () => {
   if (footerRef.current) observer.unobserve(footerRef.current)
  }
 }, [])

 return (
  <FooterVisibilityContext.Provider value={{ isVisible }}>
   {children}
  </FooterVisibilityContext.Provider>
 )
}
